
<div class="policy-card__company-rating">
  <div class="dropdown dropdown-hover">
    <a href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
      class="dropdown-toggle dropdown-toggle--nocaret d-none d-md-block">
      <div class="stars" >
        @for (star of getStars(); track $index) {
          <div class="stars__star">
            <svg class="icon">
              <use xlink:href="#star-inactive"></use>
            </svg>
            <div class="stars__percent stars__percent--{{star}}">
              <svg class="icon">
                <use xlink:href="#star-active"></use>
              </svg>
            </div>
          </div>
        }

      </div>
    </a>
    <div class="dropdown-menu {{position}} dropdown-menu--ratings">
      <div class="ratings-info">
        <div class="ratings-info__avatar">
          <img src="assets/3/avatar/happy-cropped.png" alt="" class="img-fluid">
        </div>
        <div class="ratings-info__content">
          <h5>How we calculate ratings</h5>
          <p>This rating is based on whether an insurer is good or not in the areas our customers care about.</p>
          <div>
            @for (rating of ratings; track rating) {
              <dl class="ratings-info__item">
                <dt>
                  <em>{{rating.rating_type}}</em>
                </dt>
                <dd>
                  <strong>{{rating.rating_score}}/{{rating.rating_denom}}</strong>
                </dd>
              </dl>
            }

          </div>

          @if (getStars()?.length>0) {
            <div class="ratings-info__overall">
              <p><strong>Overall Rating</strong></p>
              <div class="stars">
                @for (star of getStars(); track $index) {
                  <div class="stars__star">
                    <svg class="icon">
                      <use xlink:href="#star-inactive"></use>
                    </svg>
                    <div class="stars__percent stars__percent--{{star}}">
                      <svg class="icon">
                        <use xlink:href="#star-active"></use>
                      </svg>
                    </div>
                  </div>
                }
                <div class="stars__label">{{ratings[0].insurer_rating}} Stars</div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <a href="#ratings-modal" class="stars d-md-none" data-toggle="modal">
    @for (star of getStars(); track $index) {
      <div class="stars__star">
        <svg class="icon">
          <use xlink:href="#star-inactive"></use>
        </svg>
        <div class="stars__percent stars__percent--{{star}}">
          <svg class="icon">
            <use xlink:href="#star-active"></use>
          </svg>
        </div>
      </div>
    }

  </a>

</div>
@if (position=='') {
  <div class="modal fade modal--fullscreen" id="ratings-modal" tabindex="-1" role="dialog" aria-labelledby="ratings-modal" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-ratings__title">
          <button class="modal-ratings__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-circle-small"></use>
            </svg>
          </button>
        </div>
        <div class="modal-ratings__content">
          <div class="container">
            <div class="ratings-info">
              <div class="ratings-info__content">
                <div class="ratings-info__company">
                  <div class="ratings-info__company-thumb">
                    <img src="assets/insurer/{{ratings[0].insurer_id}}.svg" class="img-fluid">
                  </div>
                  <div class="ratings-info__company-rating">
                    <div class="stars-compact">
                      <div class="stars-compact__star">
                        <svg class="icon">
                          <use xlink:href="#star"></use>
                        </svg>
                      </div>
                      <div class="stars-compact__num">{{ratings[0].insurer_rating}}</div>
                    </div>
                  </div>
                </div>
                <h5>How we calculate ratings</h5>
                <p>This rating is based on whether an insurer is good or not in the areas our customers care about.</p>
                <div>
                  @for (rating of ratings; track rating) {
                    <dl class="ratings-info__item">
                      <dt>
                        <em>{{rating.rating_type}}</em>
                      </dt>
                      <dd>
                        <strong>{{rating.rating_score}}/{{rating.rating_denom}}</strong>
                      </dd>
                    </dl>
                  }
                </div>
                <div class="ratings-info__overall">
                  <p><strong>Overall Rating</strong></p>
                  <div class="stars">
                    @for (star of getStars(); track $index) {
                      <div class="stars__star">
                        <svg class="icon">
                          <use xlink:href="#star-inactive"></use>
                        </svg>
                        <div class="stars__percent stars__percent--{{star}}">
                          <svg class="icon">
                            <use xlink:href="#star-active"></use>
                          </svg>
                        </div>
                      </div>
                    }
                    <div class="stars__label">{{ratings[0].insurer_rating}} Stars</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

